/* eslint-disable no-console */
import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';
import { Formik, Form } from 'formik';
import Box from 'ui-box';
import { Button } from 'antd';
import InputSelectField from '../form-helpers/InputSelectField';
import { FormInputArea } from '../form-helpers/FormField';
import LoadingSpinner from '../../common/LoadingSpinner';
import { errorNotification } from '../../../utils/notification-helpers';
import SharedWithList from './SharedWithList';

const data = [
  {label: 'Agomelatine', value: 'Agomelatine'},
  {label: 'Azelaic Acid', value: 'Azelaic Acid'},
  {label: 'Azelastine hydrochloride nasal spray', value: 'Azelastine hydrochloride nasal spray'},
  {label: 'Malatonin', value: 'Malatonin'},
]

const formItemLayout = {
  labelCol: {
    span: 24,
  },
  wrapperCol: {
    span: 24,
  }
}

function AlergiesForm({ onSubmitBtnText, onSubmitForm, dataMedicalHistory }) {
  const { t } = useTranslation(['common', 'medical-history']);
  const [lists, setLists] = useState([]);

  const FormSchema = useMemo(
    () =>
      Yup.object().shape({
        allergies: Yup.string().required(t('form.error.required'))
      }),
    [t]
  );

  const initialValues = {
    allergies: dataMedicalHistory && dataMedicalHistory.allergies ? dataMedicalHistory.allergies : '',
  };

  const handleChange = (name, val) => {
    const temp = {label: val, value: val};
    const arr = [...lists, temp];
    setLists(arr);
  }

  const onRemove = (val) => {
    const arr = lists.filter((obj) => {
      return obj.value !== val;
    });
    setLists(arr);
  }

  return (
    <div style={{ width: '100%', textAlign: 'left' }}>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={FormSchema}
        onSubmit={async (values) => {
          const dataForm = dataMedicalHistory ?? {};
          dataForm.allergies = values.allergies
          console.log("dataForm", dataForm)
          onSubmitForm(dataForm)
        }}
      >
        {({ isSubmitting, isValid, setFieldValue }) => {
          return (
            <Form>
              <fieldset disabled={isSubmitting}>
                <FormInputArea
                  name="allergies"
                  style={{ width: '100%', padding: '3%' }}
                  formItemLayout={formItemLayout}
                  onChange={(e) => setFieldValue("allergies", e.target.value)}
                  rows={6}
                />
                {/* <InputSelectField
                  name="allergies"
                  label={t('medical-history:allergies.form.enterAllergy.label')}
                  placeholder={t('medical-history:allergies.form.enterAllergy.placeholder')}
                  options={data}
                  handleChange={handleChange}
                />
                <Box>
                  <SharedWithList
                    title={t('medical-history:allergies.form.yourAllergies.label')}
                    emptyTitle={t('medical-history:allergies.form.yourAllergies.noSelected')}
                    list={lists}
                    onRemove={onRemove} />
                </Box> */}
                <Box paddingTop={15}>
                  <Button
                    disabled={isSubmitting || !isValid}
                    loading={isSubmitting}
                    htmlType="submit"
                    type="primary"
                    size="large"
                    block
                  >
                    {isSubmitting ? <LoadingSpinner position="full" transparent={false} /> : onSubmitBtnText}
                  </Button>
                </Box>
              </fieldset>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
}

AlergiesForm.defaultProps = {
  onSubmitBtnText: 'Save & Update',
};

const { string, func } = PropTypes;

AlergiesForm.propTypes = {
  onSubmitBtnText: string,
  onSubmitForm: func.isRequired,
  dataMedicalHistory: PropTypes.objectOf(PropTypes.any).isRequired
};

export default AlergiesForm;
